export default function NotFound() {
    return (
        <div>Oops - we've looked everywhere but could not find what you are looking for!</div>
    )
}
